export const MOBILE_BREAKPOINT: number = 576;
